import { IStorage } from './types';

export * from './types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const storage: IStorage = __WEB__ ? require('./web').default : require('./native').default;

export default storage;
